import focus from './focus';
import clickaway from './clickaway';
import restrict from './restrict';

export default [focus, clickaway, restrict];
